export interface SitemapItem {
  name: string;
  path: string;
  available: boolean;
}

export interface SitemapCategory {
  title: string;
  items: SitemapItem[];
}

export const sitemapData: SitemapCategory[] = [
  {
    title: "Financial Calculators",
    items: [
      { name: "Tip Calculator", path: "/special/tip", available: true },
      { name: "Mortgage Calculator", path: "/special/mortgage", available: true },
      { name: "Loan Calculator", path: "/special/loan", available: true },
      { name: "Percentage Calculator", path: "/special/percentage", available: true },
      { name: "Auto Loan Calculator", path: "/special/auto", available: true },
      { name: "Investment Calculator", path: "/special/investment", available: true },
      { name: "Retirement Calculator", path: "/special/retirement", available: true },
      { name: "Tax Calculator", path: "/special/tax", available: true },
      { name: "Salary Calculator", path: "/special/salary", available: true },
      { name: "Interest Calculator", path: "/special/interest", available: true },
      { name: "Debt Calculator", path: "/special/debt", available: true },
      { name: "Digital Ad Break-Even Calculator", path: "/special/digital-ad-breakeven", available: true },
      { name: "Compound Interest Calculator", path: "/special/compound-interest", available: true },
      { name: "ROI Calculator", path: "/special/roi", available: true },
      { name: "NPV Calculator", path: "/special/npv", available: true },
      { name: "CAGR Calculator", path: "/special/cagr", available: true },
      { name: "DTI Calculator", path: "/special/dti", available: true },
      { name: "Discount Calculator", path: "/special/discount", available: true },
      { name: "Emergency Fund Calculator", path: "/special/emergency-fund", available: true },
      { name: "Net Worth Calculator", path: "/special/net-worth", available: true },
    ]
  },
  {
    title: "Health & Fitness Calculators",
    items: [
      { name: "BMI Calculator", path: "/special/bmi", available: true },
      { name: "Pregnancy Calculator", path: "/special/pregnancy", available: true },
      { name: "Pregnancy Weight Gain Calculator", path: "/special/pregnancy-weight", available: true },
      { name: "Pregnancy Conception Calculator", path: "/special/pregnancy-conception", available: true },
      { name: "Due Date Calculator", path: "/special/due-date", available: true },
      { name: "Ovulation Calculator", path: "/special/ovulation", available: true },
      { name: "Conception Calculator", path: "/special/conception", available: true },
      { name: "Period Calculator", path: "/special/period", available: true },
      { name: "Calorie Calculator", path: "/special/calories", available: true },
      { name: "Body Fat Calculator", path: "/special/bodyfat", available: true },
      { name: "BMR Calculator", path: "/special/bmr", available: true },
      { name: "Ideal Weight Calculator", path: "/special/ideal-weight", available: true },
      { name: "GFR Calculator", path: "/special/gfr", available: true },
    ]
  },
  {
    title: "Time & Date Calculators",
    items: [
      { name: "Age Calculator", path: "/special/age", available: true },
      { name: "Date Calculator", path: "/special/date", available: false },
    ]
  },
  {
    title: "Unit Converters",
    items: [
      { name: "Length Converter", path: "/converters/length", available: true },
      { name: "Weight Converter", path: "/converters/weight", available: true },
      { name: "Volume Converter", path: "/converters/volume", available: true },
      { name: "Temperature Converter", path: "/converters/temperature", available: true },
      { name: "Area Converter", path: "/converters/area", available: true },
      { name: "Pressure Converter", path: "/converters/pressure", available: true },
      { name: "Energy Converter", path: "/converters/energy", available: true },
      { name: "Power Converter", path: "/converters/power", available: true },
      { name: "Force Converter", path: "/converters/force", available: true },
      { name: "Time Converter", path: "/converters/time", available: true },
      { name: "Speed Converter", path: "/converters/speed", available: true },
      { name: "Angle Converter", path: "/converters/angle", available: true },
      { name: "Fuel Consumption Converter", path: "/converters/fuel", available: true },
      { name: "Digital Storage Converter", path: "/converters/digital", available: true },
      { name: "Currency Converter", path: "/converters/currency", available: true },
      { name: "Data Transfer Rate Converter", path: "/converters/data-transfer", available: true },
    ]
  },
  {
    title: "Statistical Calculators",
    items: [
      { name: "ANOVA Calculator", path: "/special/anova", available: true },
      { name: "Binomial Distribution Calculator", path: "/special/binomial-distribution", available: true },
      { name: "Chi-Square Calculator", path: "/special/chi-square", available: true },
    ]
  },
  {
    title: "Mathematical Calculators",
    items: [
      { name: "Bessel Functions Calculator", path: "/special/bessel-functions", available: true },
    ]
  },
  {
    title: "Education Calculators",
    items: [
      { name: "GPA Calculator", path: "/special/gpa", available: true },
    ]
  },
  {
    title: "Blog",
    items: [
      { name: "All Blog Posts", path: "/blog", available: true },
      { name: "Mortgage Calculator Guide", path: "/blog/how-to-use-mortgage-calculator-effectively", available: true },
      { name: "Understanding BMI", path: "/blog/understanding-bmi-beyond-numbers", available: true },
      { name: "Conversion Tools Guide", path: "/blog/best-conversion-tools-everyday-use", available: true },
      { name: "Ultimate Pregnancy Weight Gain Calculator", path: "/blog/ultimate-pregnancy-weight-gain-calculator", available: true },
      { name: "Debt Freedom: Snowball vs. Avalanche Calculator", path: "/blog/debt-freedom-snowball-vs-avalanche-calculator", available: true },
      { name: "Pregnancy BMI Calculator", path: "/blog/pregnancy-bmi-calculator-monitor-weight-by-trimester", available: true },
      { name: "Master Your Finances: Debt Avalanche Guide", path: "/blog/master-finances-guide-debt-avalanche-calculators", available: true },
      { name: "From Conception to Delivery: Weight Gain Calculators", path: "/blog/conception-to-delivery-weight-gain-calculators-healthy-pregnancy", available: true },
    ]
  }
];
